import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import CGVPage from "@/pages/CGVPage";
import DiagnosticPage from "@/pages/DiagnosticPage";
import MetierLandingPage from "@/pages/MetierLandingPage";
import AdminPage from "@/pages/admin/AdminPage";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider } from "@/contexts/AdminAuthContext";
import DynamicMetaTags from "@/components/DynamicMetaTags";
import DynamicColors from "@/components/DynamicColors";
import { WhatsAppButton } from "@/components/WhatsAppButton";

function App() {
  return (
    <AdminAuthProvider>
      <div className="App">
        <DynamicMetaTags />
        <DynamicColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/confirmation" element={<ConfirmationPage />} />
            <Route path="/cgv" element={<CGVPage />} />
            <Route path="/diagnostic" element={<DiagnosticPage />} />
            <Route path="/metier/:metier" element={<MetierLandingPage />} />
            <Route path="/metier/:metier/:ville" element={<MetierLandingPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
        <WhatsAppButton />
      </div>
    </AdminAuthProvider>
  );
}

export default App;
